import { render, staticRenderFns } from "./SidebarNavProfile.vue?vue&type=template&id=3d19b51f&"
import script from "./SidebarNavProfile.vue?vue&type=script&lang=js&"
export * from "./SidebarNavProfile.vue?vue&type=script&lang=js&"
import style0 from "./SidebarNavProfile.vue?vue&type=style&index=0&id=3d19b51f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports